import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
// @ts-expect-error Vite ?inline import
import styles from './widget-styles.css?inline'

class TuttoFoodChatWidget extends HTMLElement {
  private root: ReactDOM.Root | null = null
  private shadow: ShadowRoot

  static get observedAttributes() {
    return ['api-url']
  }

  constructor() {
    super()
    this.shadow = this.attachShadow({ mode: 'open' })
  }

  connectedCallback() {
    // Idempotent: only inject if not already present (handles reconnection)
    if (!this.shadow.querySelector('style')) {
      const styleSheet = document.createElement('style')
      styleSheet.textContent = styles
      this.shadow.appendChild(styleSheet)
    }

    if (!this.shadow.querySelector('#tuttofood-widget-root')) {
      const mountPoint = document.createElement('div')
      mountPoint.id = 'tuttofood-widget-root'
      this.shadow.appendChild(mountPoint)

      // Get optional api-url attribute
      const apiUrl = this.getAttribute('api-url') || undefined

      this.root = ReactDOM.createRoot(mountPoint)
      this.root.render(
        <React.StrictMode>
          <App apiUrl={apiUrl} />
        </React.StrictMode>
      )
    }
  }

  disconnectedCallback() {
    this.root?.unmount()
    this.root = null
  }
}

// Only register if not already registered
if (!customElements.get('chat-widget')) {
  customElements.define('chat-widget', TuttoFoodChatWidget)
}
